import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _Filter(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, d: "M5 12V4M19 20v-2M5 20v-4M19 12V4M12 7V4M12 20v-8" }),
            React.createElement("circle", { cx: 5, cy: 14, r: 2, stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2 }),
            React.createElement("circle", { cx: 12, cy: 9, r: 2, stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2 }),
            React.createElement("circle", { cx: 19, cy: 15, r: 2, stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2 })));
}
const Filter = forwardRef(_Filter);
export { Filter };
